import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import snackbar from './snackbar';

/**
 Show snackbar when request has Error
 * */

const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // pass preventSnackbar<boolean | true> as rtk hook request args if you prefer to prevent show snackbar
    const preventShowSnackbar = action?.meta?.arg.originalArgs?.preventSnackbar;
    const alreadyHandled = (
      action.payload as { customHandledSnackbar?: boolean }
    )?.customHandledSnackbar;

    // ✅ DON'T show snackbar for 401 (tokenMiddleware handles it)
    const is401 = action.payload.status === 401;

    if (
      action.payload.data?.message &&
      !preventShowSnackbar &&
      !alreadyHandled &&
      !is401
    ) {
      snackbar.error(action.payload.data?.message);
    }
  }

  return next(action);
};

export default rtkQueryErrorLogger;
